import i18n from "../i18n.js";

export default {
  install(Vue) {
    Vue.prototype.$sitesTypeLookup = {
      staticip: i18n.t("Static IP"),
      dynamicip: i18n.t("Dynamic IP"),
      dynamicdns: i18n.t("Dynamic DNS"),
      roaming: i18n.t("Roaming"),
      virtual: i18n.t("Virtual"),
    };
  },
};
